export const HEADER = {
  height: 100,
  mobileHeight: 54
};
